import { render, staticRenderFns } from "./OrderTableRow.vue?vue&type=template&id=79c227c5&scoped=true&"
import script from "./OrderTableRow.vue?vue&type=script&lang=js&"
export * from "./OrderTableRow.vue?vue&type=script&lang=js&"
import style0 from "./OrderTableRow.vue?vue&type=style&index=0&id=79c227c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c227c5",
  null
  
)

export default component.exports